import React, {useState} from "react"
import { Link } from "gatsby"
import Navigation from "../Navigation/Navigation"
import Hamburger from "../Hamburger/Hamburger"
import OverlayMenu from "../OverlayMenu/OverlayMenu"
import { useMenuQuery } from "../../hooks/useMenuQuery"
import { Wrapper, Content } from './Header.styles'

import Logo from '../../images/Petauri_KinectMax_logoCombo.png'


const Header = () => {

    const {site, wpMenu} = useMenuQuery();

    // Prop name | Setter
    const [menuOpen, setMenuOpen] = useState(false);
    const handleOverlayMenu = () => setMenuOpen(prev => !prev)

    return(
        <Wrapper>
            <Content>
                <Link to="/">
                    <img className="main-logo" src={Logo} alt={site.siteMetadata.title}/>
                </Link>

                <Hamburger menuOpen={menuOpen} handleOverlayMenu={handleOverlayMenu}/>
                <OverlayMenu menuOpen={menuOpen} callback={handleOverlayMenu}/>
                
                <Navigation menu={wpMenu.menuItems.nodes}/>
            </Content>
        </Wrapper>
    )
}

export default Header